<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-col
            cols="12"
            lg="6"
            class="d-flex align-center justify-end py-2 px-0"
            v-if="this.state === 'edit'"
        >
          <v-btn small outlined color="grey darken-2" @click="$router.back()">
            <v-icon small left>mdi-arrow-left-bold</v-icon>
            Geri
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              small
              dark
              outlined
              color="red darken-4"
              class="mr-4"
              @click="deleteWidgetConfirm(widgetSysName)"
          >
            <v-icon small left>mdi-delete</v-icon>
            Kaldır
          </v-btn>
          <v-btn small dark color="green" @click="editWidgetList">
            <v-icon small left>mdi-update</v-icon>
            Güncelle
          </v-btn>
        </v-col>
        <v-col
            cols="12"
            lg="6"
            class="d-flex align-center justify-end py-2 px-0"
            v-else
        >
          <v-btn small outlined color="grey darken-2" @click="$router.back()">
            <v-icon small left>mdi-arrow-left-bold</v-icon>
            Geri
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small dark color="blue" @click="addWidgetList">
            <v-icon small left>mdi-view-grid-plus</v-icon>
            Widget'ı Ekle
          </v-btn>
        </v-col>
      </v-col>
      <v-col lg="6">
        <h1 class="title font-weight-light mb-2 black--text">
          <v-icon left color="black">mdi-widgets</v-icon>
          <span id="widgetNameEdit">
            {{
              this.state === "edit"
                  ? `Widget Düzenle: ${widgetName}`
                  : "Yeni Widget Ekle"
            }}
          </span>
          <v-divider class="mt-2"></v-divider>
        </h1>
        <p class="text-caption grey--text text--darken-2 mb-2">
          Widget adını girin
        </p>
        <v-row>
          <v-col cols="12" lg="12">
            <v-text-field
                prepend-inner-icon="mdi-chevron-right"
                class="mb-3 font-weight-light"
                label="Widget Adı"
                hide-details
                solo
                v-model="widgetName"
            ></v-text-field>
            <v-text-field
                prepend-inner-icon="mdi-chevron-right"
                class="font-weight-light"
                label="Widget Sistem Adı (Opsiyonel)"
                hide-details
                solo
                v-model="widgetSysName"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" lg="12">
            <h4 class="text-body-1 font-weight-regular">
              <v-icon>mdi-playlist-minus</v-icon>
              Widget Listesi
            </h4>
            <v-divider></v-divider>
            <p class="text-caption grey--text text--darken-2 mb-0">
              Widget'ları sürükleyerek düzenleyin
            </p>
          </v-col>
        </v-row>

        <!--    Language Data    -->
        <language-structured-data
            v-if="widgetList"
            ref="languageStructuredData"
            v-model="widgetList"
            @change="languageStructuredIsChanged"
        >
          <template v-slot="{ data }">
            <div>
              <!--              <draggable-tree :data="data.widgetList" draggable="draggable" cross-tree="cross-tree">-->
              <!--                <div slot-scope="{data, store}">-->
              <!--                  <template v-if="!data.isDragPlaceHolder">-->
              <!--                    <b v-if="data.children &amp;&amp; data.children.length"-->
              <!--                                                              @click="store.toggleOpen(data)">{{-->
              <!--                      data.open ? '-' : '+'-->
              <!--                    }}&nbsp;</b>-->
              <!--                    <span>{{ data.name }}</span>-->
              <!--                  </template>-->
              <!--                </div>-->
              <!--              </draggable-tree>-->
              <div
                  id="trashZoneContainer"
                  class="col-12 col-lg-12 px-0 footer"
                  v-if="widgetListStart"
              >
                <div
                    id="widgetTrashZone"
                    class="text-center red lighten-1 rounded"
                >
                  <span class="text-body-1 font-weight-regular white--text">
                    <v-icon size="20" dark>mdi-trash-can</v-icon>
                    Kaldır
                  </span>
                  <!--                  <Draggable-->
                  <!--                      v-model="trashZone"-->
                  <!--                      class="dropzone trashzone"-->
                  <!--                      :options="trashOptions"-->
                  <!--                  >-->
                  <!--                    <div id="trashZone" slot="footer"></div>-->
                  <!--                  </Draggable>-->
                </div>
              </div>
            </div>
          </template>
        </language-structured-data>
        <!--    ./Language Data    -->
        <div v-if="widgetList">
          <v-row v-if="preparedForWidgetList.length === 0">
            <v-col lg="12" class="py-0">
              <div class="widget-list-drag-drop-empty">
                <v-list class="widget-list-empty">
                  <v-list-item class="widget-list-empty-item">
                    <v-list-item-content>
                      <v-list-item-title
                          class="widget-list-empty-title text-center text-body-2 font-weight-medium"
                      >
                        <div v-if="widgetStart">
                          Buraya Bırak
                          <v-icon left color="#005194">mdi-hand</v-icon>
                        </div>
                        <div v-else>
                          Widget Listesine Ekleme Yapmak İçin Sürükle
                          Bırak'ı Kullanın
                        </div>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
          </v-row>
          <draggable-widget
              ref="widgetDraggableComp"
              class="col-lg-12"
              :class="[
                preparedForWidgetList.length === 0
                  ? 'widget-container-empty'
                  : ''
                ]"
              v-model="preparedForWidgetList"
              @start="startWidgetList"
              @end="stopWidgetList"></draggable-widget>
          <!--          <DraggableWidget-->
          <!--              :key="key"-->
          <!--              class="col-lg-12"-->
          <!--              :class="[-->
          <!--                data.widgetList.length === 0-->
          <!--                  ? 'widget-container-empty'-->
          <!--                  : ''-->
          <!--                ]"-->
          <!--              v-model="data.widgetList"-->
          <!--              @start="startWidgetList"-->
          <!--              @end="stopWidgetList"-->
          <!--          />-->
        </div>

      </v-col>
      <v-col lg="6">
        <div class="d-flex align-center py-0 px-0">
          <h1 class="title font-weight-light black--text">
            <v-icon left color="black">mdi-widgets-outline</v-icon>
            Widget Ekle
          </h1>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small icon v-bind="attrs" v-on="on">
                <v-icon dense color="blue darken-2">mdi-autorenew</v-icon>
              </v-btn>
            </template>
            <span>Widget Listesini Yenile</span>
          </v-tooltip>
        </div>
        <v-divider class="mb-2 mt-2"></v-divider>
        <p class="text-caption grey--text text--darken-2 mb-2">
          Kullanılabilir widgetların listesi
        </p>

        <!--        <draggable-tree :data="widgets" :draggable="true">-->
        <!--          <div slot-scope="{data, store}">-->
        <!--            <template v-if="!data.isDragPlaceHolder">-->
        <!--              {{data.name}}-->
        <!--              <b v-if="data.children &amp;&amp; data.children.length"-->
        <!--                 @click="store.toggleOpen(data)">{{ data.open ? '-' : '+' }}&nbsp;</b><span>{{ data.text }}</span>-->
        <!--            </template>-->
        <!--          </div>-->
        <!--        </draggable-tree>-->
        <div :key="key" v-for="(data, key) in widgetList">
          <widget-preview
              v-if="widgetList && key === currentCode"
              :key="key"
              :group-id="key"
              :value="JSON.parse(JSON.stringify(widgets))"
              :is-draggable="true"
              :clone="clone"
              @start="startWidgets"
              @end="stopWidgets"
          />
        </div>
      </v-col>
    </v-row>

    <!--  Widget status dialog  -->
    <v-dialog v-model="widgetStatus" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          <div class="py-2 text-center">
            Widget Yükleniyor
          </div>
          <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!--  ./Widget status dialog  -->

    <!--  Delete widget dialog  -->
    <v-dialog v-model="deleteWidget.dialog" persistent max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-4">
          <v-icon left color="red darken-4">mdi-close-octagon</v-icon>
          Uyarı
        </v-card-title>
        <v-card-text>
          Widget listesini silmek istediğinizden emin misiniz ?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="deleteWidget.dialog = false">
            İptal
          </v-btn>
          <v-btn
              color="green darken-1"
              text
              :loading="deleteWidget.loading"
              @click="deleteWidgetList()"
          >
            Evet
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  ./Delete widget dialog  -->
  </v-container>
</template>

<script>
import Draggable from "vuedraggable";
import DraggableWidget from "@/components/Settings/Widgets/DraggableWidget";
import {mapState} from "vuex";
import WidgetPreview from "./WidgetPreview.vue";
import LanguageStructuredData from "@/components/LanguageStructuredData.vue";
import {prepare, prepareFromData} from "@/core/modules/LanguageStructuredData";

export default {
  name: "Widgets",
  props: {
    state: {}
  },
  components: {
    LanguageStructuredData,
    WidgetPreview,
    Draggable,
    DraggableWidget,
  },
  data() {
    return {
      widgetStatus: this.state === "edit",
      widget: "",
      widgetStart: false,
      widgetListStart: false,
      widgetList: null,
      editWidgetList_l: null,
      idCount: 0,
      widgetCode: Number,
      widgetName: "",
      widgetSysName: "",
      widgetNameFocus: false,
      langDetail: null,
      preparedForWidgetList: [],
      trashZone: [],
      trashOptions: {
        group: {
          name: "trash",
          draggable: false,
          put: () => true,
          pull: false
        }
      },
      deleteWidget: {
        sysName: "",
        dialog: false,
        loading: false
      },

      currentCode: null,

      // draggableWidgetComps: {},
    };
  },
  computed: {
    ...mapState({
      getWidgetList: state => state.Widget.WidgetLists.widgetList,
      apiLanguage: state => state.Language.apiLanguage
    }),

    currentWidgetList() {
      return this.widgetList[this.$refs.languageStructuredData.currentCode].widgetList;
    },

    currentLanguageCode() {
      return this.currentCode || this.apiLanguage;
    },

    editWidgetListCode() {
      return this.$route.params.widgetID || null;
    },

    /**
     *  Kullanılabilir Widgets Listesini Getir
     */
    widgets() {
      return this.setWidgetsToUsable(
          this.$store.state.Widget.Widgets.widgets
      );
    }
  },
  methods: {
    countElements(widgetList, key = "elements") {
      let count = 0;
      widgetList.forEach(el => {
        if (el[key].length > 0) {
          count += this.countElements(el[key]);
        }
        count++;
      });
      return count;
    },
    getIDlist(widgetList, key = "elements") {
      if (widgetList.length === 0) return 0;
      let ids = [];
      widgetList.forEach(el => {
        if (el[key].length > 0) {
          ids = ids.concat(this.getIDlist(el[key]));
        }
        ids.push(parseInt(el.id));
      });
      return ids;
    },
    lastID() {
      let list = this.getIDlist(this.preparedForWidgetList);
      if (list === 0) return 0;
      else return Math.max(...list);
    },
    /**
     *  Widget onClone
     */
    clone(cloneData) {
      let id = this.idCounter();
      cloneData = JSON.parse(JSON.stringify(cloneData));
      cloneData.id = id;
      cloneData.name =
          cloneData.name + " " + this.countElements(this.preparedForWidgetList);
      return JSON.parse(JSON.stringify(cloneData));
    },
    /**
     *  Random idCounter
     */
    idCounter() {
      return this.lastID() + 1;
    },
    /**
     *  Widget Drag/Drop Event Stating
     */
    startWidgets() {
      this.widgetStart = true;
    },
    stopWidgets() {
      this.widgetStart = false;
    },
    /**
     * Widget List Drag/Drop Event Stating
     */
    startWidgetList() {
      this.widgetListStart = true;
    },
    stopWidgetList() {
      this.widgetListStart = false;
    },
    /**
     * Sisteme yeni bir widget listesi eklemesi yapar
     */
    addWidgetList() {
      const {widgetName, widgetSysName, widgetList} = this;
      this.$store
          .dispatch("Widget/WidgetLists/addWidgetList", {
            widgetName,
            widgetSysName,
            _l: widgetList
          })
          .then(res => {
            if (res.status === 200) {
              this.$snotify.success("Widget başarıyla eklenmiştir", this.$t('PANEL.NOTIFY.SUCCESS'));
              // this.$router.push('/widget-management/widgets')
              this.$router.back();
            } else {
              this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
            }
          });
    },
    editWidgetList() {
      const {widgetCode, widgetName, widgetSysName, widgetList} = this;
      this.$store
          .dispatch("Widget/WidgetLists/editWidgetList", {
            widgetCode,
            widgetName,
            widgetSysName,
            _l: widgetList
          })
          .then(res => {
            if (res.status === 200) {
              this.$snotify.success(
                  "Widget başarıyla güncellenmiştir",
                  this.$t('PANEL.NOTIFY.SUCCESS')
              );
            } else {
              this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
            }
          });
    },
    deleteWidgetList() {
      const widgetListSysName = this.deleteWidget.sysName;

      this.$store
          .dispatch("Widget/WidgetLists/deleteWidgetList", widgetListSysName)
          .then(res => {
            if (res.status === 200) {
              this.$snotify.success(
                  "Widget başarıyla kaldırılmıştır",
                  this.$t('PANEL.NOTIFY.SUCCESS')
              );
              this.$router.push("/settings/widgets");
            } else {
              this.$snotify.error(res.data.errMessage, this.$t('PANEL.NOTIFY.ERROR'));
            }
          });
    },
    deleteWidgetConfirm(widgetListSysName) {
      this.deleteWidget.dialog = true;
      this.deleteWidget.sysName = widgetListSysName;
    },
    /**
     * Gelen widget listesini kullanılabilir
     * bir format için hazırlar
     */
    setWidgetsToUsable(widgets) {
      let widgetsList = [];

      if (!widgets) return [];

      widgets.forEach((widget, key) => {
        widgetsList.push({
          id: key,
          name: widget.name,
          widget: widget.sysname,
          fields: widget.fields.map(fields => {
            return (fields = Object.assign(
                fields,
                fields.name === "icon" ? {value: "mdi-"} : {value: ""}
            ));
          }),
          permission: [],
          elements: []
        });
      });
      return widgetsList;
    },
    /**
     * API'den boş değerler string geldiği için
     * string to array parser
     */
    elementsStringToArray(items, key = "elements") {
      let newItems = [];
      items.forEach(item => {
        if (item[key] == "") {
          item[key] = [];
        } else if (item[key].length > 0) {
          item[key] = this.elementsStringToArray(item[key]);
        }
        newItems.push(item);
      });
      return newItems;
    },

    languageStructuredIsChanged({oldCode, currentCode}) {
      this.currentCode = currentCode;

      if (this.widgetList[currentCode].widgetList.length) {
        this.preparedForWidgetList = JSON.parse(JSON.stringify(this.widgetList[currentCode].widgetList));
      } else {
        this.preparedForWidgetList = [];
      }
    },

    // cloneDataById(targetId) {
    //   const newData = this.clone(this.widgets[0]);
    //
    //   const currentWidgetList = this.widgetList[this.currentLanguageCode].widgetList;
    //
    //   for (let i = 0; i < currentWidgetList.length; i++) {
    //     if (currentWidgetList[i].id === targetId) {
    //       currentWidgetList.splice(i + 1, 0, newData); // Bir sonraki index'e klonlayacağız
    //       return;
    //     }
    //
    //     if (currentWidgetList[i].elements && currentWidgetList[i].elements.length > 0) {
    //       this.cloneDataById(currentWidgetList[i].elements, targetId, newData);
    //       // Eğer eleman bulunduysa, artık aramayı sonlandırabiliriz.
    //       // Aksi takdirde, iç içe elemanları dolaşmaya devam eder.
    //       if (data[i].elements.find((item) => item.id === targetId)) {
    //         return;
    //       }
    //     }
    //   }
    //
    //   this.$refs.widgetDraggableComp.$forceUpdate()
    // }
  },
  created() {
    /**
     * Kullanılabilir widget listesini getir
     */
    if (!this.getWidgetList.length) {
      this.$store.dispatch("Widget/Widgets/getWidgets");
    }

    /**
     * Düzenleme ise verileri al
     */
    if (this.state === "edit") {
      return new Promise(resolve => {
        if (this.getWidgetList.length > 0) {
          resolve(this.getWidgetList);
        } else {
          this.$store
              .dispatch("Widget/WidgetLists/getWidgetList", {
                widgetListCode: Number(this.$route.params.widgetID)
              })
              .then(res => {
                resolve(res.data);
              });
        }
      })
          .then(widgetData => {
            const currentWidgetData = widgetData.find(
                o => o.lang === this.apiLanguage
            );
            this.widgetCode = currentWidgetData.code;
            this.widgetName = currentWidgetData.name;
            this.widgetSysName = currentWidgetData.sysname;

            this.widgetList = prepareFromData(widgetData, {items: 'widgetList'});
            // widgetData.forEach(widgetLangItem => {
            //   widgetLangItem[widgetLangItem.lang].widgetList =
            //       widgetLangItem[widgetLangItem.lang].items;
            //   delete widgetLangItem[widgetLangItem.lang].items;
            // });
            // this.editWidgetList_l = widgetData;
            // widgetData.forEach(widgetLangItem => {
            //   this.widgetList[widgetLangItem.lang].widgetList = this.elementsStringToArray(widgetLangItem.items);
            // })
          })
          .then(() => {
            setTimeout(() => {
              this.widgetStatus = false;
            }, 300);
          })
          .catch(err => {
            console.error(err);
          });
    } else {
      this.widgetList = prepare(this.apiLanguage, {
        widgetList: []
      });
    }
  },

  watch: {
    // 'currentLanguageCode': {
    //   handler(value) {
    //     if (!this.widgetList) {
    //       this.draggableWidgetComps[this.currentLanguageCode] = () => import('@/components/Settings/Widgets/DraggableWidget.vue')
    //       return;
    //     }
    //
    //     Object.keys(this.widgetList).forEach(languageCode => {
    //       if (!this.draggableWidgetComps[languageCode] || !this.draggableWidgetComps[this.currentLanguageCode]) {
    //         this.draggableWidgetComps[languageCode] = () => import('@/components/Settings/Widgets/DraggableWidget.vue');
    //       }
    //     })
    //
    //   },
    //   deep: true,
    //   immediate: true
    // },

    currentCode: {
      handler() {

        // console.log(this.$refs.widgetDraggableComp.$forceUpdate())
      },
      deep: true,
    },

    preparedForWidgetList: {
      handler(value) {
        this.widgetList[this.currentLanguageCode].widgetList = JSON.parse(JSON.stringify(this.preparedForWidgetList));
        // if (this.widgetList[oldCode]) {
        //   this.widgetList[oldCode].widgetList = JSON.parse(JSON.stringify(this.preparedForWidgetList));
        // }
      },
      deep: true,
    }
  },
};
</script>

<style>
#widgetNameEdit {
  position: relative;
}

#widgetNameEdit span {
  padding-right: 30px;
}

#widgetNameEdit .edit-icon {
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  pointer-events: none;
}

.widgets-icon {
  left: -10px;
  height: 10px;
  cursor: grab;
}

.widget-list-drag-drop-empty {
  position: relative;
  top: 7px;
}

.widget-list-empty {
  background: rgba(0, 136, 249, 0.09) !important;
  border: 1px dashed #0088f8 !important;
  position: absolute;
  width: 100%;
}

.widget-list-empty-item {
  min-height: 40px;
}

.widget-list-empty-title {
  color: #005194;
}

.dropzone.trashzone {
  position: relative;
  padding: 6px 6px 0 6px;
  height: 60px;
}

@keyframes opacity {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

#trashZoneContainer {
  animation: 350ms opacity;
}

#trashZone {
  position: absolute;
}

#widgetTrashZone {
  position: relative;
}

#widgetTrashZone span {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
